import React from 'react'
import { Icon } from 'semantic-ui-react'

import styles from './styles'

const MainInfo = ({ icon = null, iconName, title, text }) => {
  return (
    <div style={styles.iconTextContainer}>
      <div style={styles.icon}>
        {icon || <Icon name={iconName} />}
      </div>
      <div style={styles.title}>{title}</div>
      <div style={styles.text}>{text}</div>
    </div>
  )
}

export default MainInfo
